export const QUICK_ENTRY_USER_STORAGE_KEY = 'quickEntryUser';

export const MEDALLION_USERS = ['Farah', 'Omnia', 'Rewaa', 'Sara', 'Areeb', 'Youssef', 'Safa'] as const;

export type QuickEntryUser = (typeof MEDALLION_USERS)[number];

export const normalizeQuickEntryUser = (value?: string | null): QuickEntryUser | '' => {
  const trimmedValue = (value || '').trim();
  if (!trimmedValue) return '';

  return MEDALLION_USERS.find((user) => user.toLowerCase() === trimmedValue.toLowerCase()) || '';
};

export const getStoredQuickEntryUser = (): QuickEntryUser | '' => {
  const storedUser = normalizeQuickEntryUser(localStorage.getItem(QUICK_ENTRY_USER_STORAGE_KEY));
  if (!storedUser && localStorage.getItem(QUICK_ENTRY_USER_STORAGE_KEY)) {
    localStorage.removeItem(QUICK_ENTRY_USER_STORAGE_KEY);
  }
  return storedUser;
};

export const setStoredQuickEntryUser = (value?: string | null): QuickEntryUser | '' => {
  const normalizedUser = normalizeQuickEntryUser(value);
  if (normalizedUser) {
    localStorage.setItem(QUICK_ENTRY_USER_STORAGE_KEY, normalizedUser);
  } else {
    localStorage.removeItem(QUICK_ENTRY_USER_STORAGE_KEY);
  }
  return normalizedUser;
};

export const clearStoredQuickEntryUser = () => {
  localStorage.removeItem(QUICK_ENTRY_USER_STORAGE_KEY);
};

export const quickEntryUserMatches = (value: string | undefined, quickEntryUser: string) =>
  !quickEntryUser || normalizeQuickEntryUser(value) === quickEntryUser;

export const appendQuickEntryUserToUrl = (url: string, quickEntryUser = getStoredQuickEntryUser()) => {
  if (!quickEntryUser) return url;

  try {
    const parsedUrl = new URL(url, window.location.origin);
    parsedUrl.searchParams.set('user', quickEntryUser);
    return /^https?:\/\//i.test(url)
      ? parsedUrl.toString()
      : `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
  } catch {
    const [baseUrl, hash = ''] = url.split('#');
    const separator = baseUrl.includes('?') ? '&' : '?';
    const nextUrl = `${baseUrl}${separator}user=${encodeURIComponent(quickEntryUser)}`;
    return hash ? `${nextUrl}#${hash}` : nextUrl;
  }
};
